import { Injectable, Inject, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/retry';
import 'rxjs/add/observable/throw';
import { Subject, BehaviorSubject } from 'rxjs';
import { environment} from '../../environments/environment';
import { Title, Meta } from  '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ISubscription } from "rxjs/Subscription";

declare var gtag: Function;

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Provide Singleton shared service methods used by components
 **/
@Injectable()
export class SharedService {
  lang;
  languageId;
  private countryUrl: string = this.config.urlCountry;
  private stateUrl: string = this.config.urlState;
  private postcodeUrl:string = this.config.urlPostcode;
  private cityUrl: string = this.config.urlCity;
  private genderUrl: string = this.config.urlGender;
  private colorUrl: string = this.config.urlColor;
  private fontUrl: string = this.config.urlFont;
  private religionUrl: string = this.config.urlReligion;
  private raceUrl: string = this.config.urlRace;
  private citizenUrl: string = this.config.urlCitizenship;
  private sharedDS: string = this.config.urlDservicePublic;
  private relationUrl: string = this.config.urlRelationship;
  private reasonUrl: string = this.config.urlReason;
  private gaTrackingId: string = this.config.googleTrackingId;
  private urlAlert = this.config.urlAlert;
  private feebackMainUrl: string = this.config.urlMainFeedback;
 
  //private tempSharedDS: string = 'http://10.1.71.168/webs/edu/';
  public  fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };
  public fontSizeData  = new Subject<any>();
  public fontTypeData = new Subject<any>();
  public bgColor = new Subject<any>();
  public invalidUserStatus = new BehaviorSubject<boolean>(false);
  public isMaintenanceShown = new BehaviorSubject<boolean>(false);
  public isAlreadyExpired = new BehaviorSubject<boolean>(false);
  public unreadEmails = new BehaviorSubject<any>('');
  public sideMenuJSON = new BehaviorSubject<any>([]);
  public sidePinNavJSON = new BehaviorSubject<any>({});
  public chatBotJSON = new BehaviorSubject<any>({});
  public searchJSON =  new BehaviorSubject<any>({});
  public autoLogoutData = new BehaviorSubject<any>(null);
  public uploadLimitData = new BehaviorSubject<any>(null);
  public currFontNum = new BehaviorSubject<number>(14);
  public themefontData = new BehaviorSubject<any>(null);
  public themecolorData = new BehaviorSubject<any>(null);
  public isProtected = new BehaviorSubject<boolean>(false);
  public registerOff = new BehaviorSubject<boolean>(false);
  private closeTimeout: number = 15000;
  private localConfigUrl = this.config.localConfigUrl;

  icon = {
    update: 'fa fa-edit',
    check: 'fa fa-check',
    times: 'fa fa-times',
    trash: 'fa fa-trash',
    plus: 'fa fa-plus',
    arrFPage: 'fa fa-step-backward',
    arrLPage: 'fa fa-step-forward',
    arrLeft: 'fa fa-angle-left',
    arrRight: 'fa fa-angle-right',
    refresh: 'fa fa-refresh',
    view: 'fa fa-eye'
  }

  pageSize =  [
    {"id": 1, "size": 10},
    {"id": 2, "size": 25},
    {"id": 3, "size": 50}
  ];
  defaultPageSize = this.pageSize[0].size;

  perikananIDBM = 20013;
  perikananIDEN = 20012;
  perikananCode = 1001;

  rangeDistance = [200, 50000];
  dashboardSaman = 52; // used for dashboard inquiry
  dashboardAgencyPDRM = 116;

  private toastSub: ISubscription;
  private toastSub2: ISubscription;
  private toastSub3: ISubscription;

  // private devUserId: string = '701212121212'; //LE CE

  // private devUserId: string = '000111010536'; //ebantuan tiada data
  // private devUserId: string = '720928035506'; //ebantuan 
  // private devUserId: string = '500817085311'; //ebantuan permohonan
  // private devUserId: string = '970123555555'; //JIM xboleh
  private devUserId: string = '881029045441'; //lesen memandu 
  // private devUserId: string = '411001055481'; //jim 
  // private devUserId: string = '311231047382'; jim
  // private devUserId: string = '840604045069'; //jpj no kenderaan
  // private devUserId: string = '840621105465'; // SPMU
  // private devUserId: string = '910621161616'; // - myidentity not verified
  // private devUserId: string = '850302015648'; //jpj summon
  // private devUserId: string = '010109070766'; // SPM not register yet
  // private devUserId: string = '980706054322'; // MUET not work
  // private devUserId: string = '990331086124'; // STPM & MUET 2018 
  // private devUserId: string = '990509086552'; // STPM & MUET 2018
  // private devUserId: string = '820227035325'; // OKU  & PDRM SUMMONS
  // private devUserId: string = '871222145031'; //pdrm summon
  // private devUserId: string = '530802085533'; // LOA3 By Galoh
  // private devUserId: string = '810328715099'; // MUET && jpj summon
  // private devUserId: string = '980112385133'; // MUET
  // private devUserId: string = '990516088687'; // MUET
  // private devUserId: string = '990606135838'; // MUET 
  // private devUserId: string = '000803030925'; // SPM  // DE006B087 2017 Keputusan belum diumumkan 
  // private devUserId: string = '000803030925'; // SPM DE006B087 2017 RESULTNOTRELEASE
  // private devUserId: string = '000803030925'; // SPM  // DE006B087 2017 Keputusan ringkasan
  // private devUserId: string = '010715011600'; // SPM  // JJ002A058 2018 Keputusan detail
  // private devUserId: string = '011103010572'; // SPM  // JH098A052 2018 Keputusan detail 
  // private devUserId: string = '840621105465'; // SPMU BA004J040 2019
  // private devUserId: string = '001102030281'; // SPMU DA002J048 2019
  // private devUserId: string = '990324136015'; // SPMU SM991J015 2019
  // private devUserId: string = '000101110111'; // SPMU TH901J014 BELUM UMUM 2019 
  // private devUserId: string = '091215060374'; // PEPERIKSAAN DALAMAN D4 
  // private devUserId: string = '070204080051'; // PEPERIKSAAN DALAMAN D6
  // private devUserId: string = '810719035656'; // PENGGAL 2019
  // private devUserId: string = '000115080718'; // PENGGAL MENENGAH
  // private devUserId: string = '050101030117'; // PENGGAL RENDAH 1
  // private devUserId: string = '060619040191'; // PENGGAL RENDAH 2
  // private devUserId: string = '070311040135'; // UPKK M00001009
  // private devUserId: string = '690203715061'; // PARENT
  // private devUserId: string = '771003135038';
  // private devUserId: string = '870814135668';
  //  private devUserId: string = '800101126666'; // NOORIJAH 800101126666
  //private devUserId: string = '990302075266';
  // private devUserId: string = '891030065537'; // MUET 2018
  //private devUserId: string = '00000000000';
  //private devUserId: string = '600216031111';
  //private devUserId: string = '010101013';
  //private devUserId: string = '011223110888';
  //private devUserId: string = '111211111111';
  //private devUserId: string = '890707055230';
  //private devUserId: string = '90111001817';
  // private devUserId: string = 'aa12345678';
 // private devUserId: string = '200206676755';
//  private devUserId: string = 'A3150754'; //non-citizen
//  private devUserId: string = '7846584954'; //non-citizen
  // private devUserId: string = '991222087288'; //citizen

//  private devUserId: string = '640125107465'; //perhilitan
//  private devUserId: string = '070324070763'; //Tingkatan 1
//  private devUserId: string = '040609140844'; //Tingkatan 4
//  private devUserId: string = '841209065160'; //Prasekolah
//  private devUserId: string = '771003135038'; //Darjah 1
  // private devUserId: string = '901013016666'; 
  // private devUserId: string = 'b432432423'; // non citizen 
  flagCancel: boolean;

  constructor(
    private route : ActivatedRoute,
    private pageTitle: Title,
    private pageMeta: Meta,
    private http: Http,
    @Inject(APP_CONFIG) private config: AppConfig,
    private translate: TranslateService,
    private toastr: ToastrService,
    private sanitizer: DomSanitizer
    ) {
          /* LANGUAGE FUNC */
    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      translate.get('HOME').subscribe((res: any) => {
        this.readPortal('language/all').subscribe((data:any) => {
          let getLang = data.list;
          let myLangData =  getLang.filter(function(val) {
            if(val.languageCode == translate.currentLang){
              this.lang = val.languageCode;
              this.languageId = val.languageId;
            }
          }.bind(this));
        })
      });
    });
    
    if(!this.languageId){
      //this.languageId = localStorage.getItem('langID'); // by N 04062018
      if(localStorage.getItem('langID')){
        this.languageId = localStorage.getItem('langID');
      }else{
        this.languageId = 1;
      }

    }

    /* LANGUAGE FUNC */
     }

     setCancelFlagStatus(val) {
      this.flagCancel = val;
     }

     getCancelFlagStatus() {
      return this.flagCancel;
     }

  getDevUserId() {
    return this.devUserId;
  }
  
  showError(message, title, callback?) {
    $('.overlay-container').css('display', 'block');
    
    let startHtml = '<div class="toast-modal-body"><div align="center" style="text-align: center;"><div class="row"><div class="col-sm-12" align="center"><h3 class="icon font-size-xl"><i class="fa fa-exclamation-triangle"></i></h2></div></div><div class="row"><div class="col-sm-12 msg"><h3 class="msg '+ this.getFontSizeClass() +'">';
    let endHtml = '</h3></div></div></div></div>';
    let toast = this.toastr.error(startHtml+message+endHtml, title);
    if (toast) {
      this.toastSub = toast.onHidden.subscribe(() => {
        $('.overlay-container').css('display', 'none');
        this.toastSub.unsubscribe();
        if (callback) {
          callback();
        }
      });   
    }
   
  }

  showSuccess(message, title, callback?) {
  
    let startHtml = '<div class="toast-modal-body"><div align="center" style="text-align: center;"><div class="row"><div class="col-sm-12" align="center"><h3 class="icon font-size-xl"><i class="fa fa-check-circle"></i></h2></div></div><div class="row"><div class="col-sm-12 msg"><h3 class="msg '+ this.getFontSizeClass() +'">';
    let endHtml = '</h3></div></div></div></div>';
    $('.overlay-container').css('display', 'block');
      let toast2 = this.toastr.success(startHtml+message+endHtml, title);
      if (toast2) {
        this.toastSub2 = toast2.onHidden.subscribe(() => {
          $('.overlay-container').css('display', 'none');
          this.toastSub2.unsubscribe();
          if (callback) {
            callback();
          }
        });  
      }
      
  }

  showSuccessPerhilitanAdd(message, title) {
   
    //let startHtml = '<div class="toast-modal-body"><div align="center" style="text-align: center;"><div class="row"><div class="col-sm-2"></div><div class="col-sm-1" align="center"><h2 class="icon font-size-xl"><i class="fa fa-check-square-o"></i></h2></div><div class="col-sm-7" ><h2 class="msg font-size-m" style="color: black;">';
    //let endHtml = '</div><div class="col-sm-2"></div></div></div></div>';
    let startHtml = '<div class="toast-modal-body"><div align="center" style="text-align: center;"><div class="row"><div class="col-sm-12" align="center"><h3 class="icon font-size-xl"><i class="fa fa-check-circle"></i></h2></div></div><div class="row"><div class="col-sm-12 msg"><h3 class="msg '+ this.getFontSizeClass() +'">';
    let endHtml = '</h3></div></div></div></div>';
    $('.overlay-container').css('display', 'block');
      let toast2 = this.toastr.success(startHtml+message+endHtml, title);
      if (toast2) {
        this.toastSub2 = toast2.onHidden.subscribe(() => {
          $('.overlay-container').css('display', 'none');
          this.toastSub2.unsubscribe();
          console.log("Dari Digital Services");
          window.close();
        });  
      }
      
  }

  showSuccessPerhilitanEdit(message, title) {
   
    //let startHtml = '<div class="toast-modal-body"><div align="center" style="text-align: center;"><div class="row"><div class="col-sm-2"></div><div class="col-sm-1" align="center"><h2 class="icon font-size-xl"><i class="fa fa-check-square-o"></i></h2></div><div class="col-sm-7" ><h2 class="msg font-size-m" style="color: black;">';
    //let endHtml = '</div><div class="col-sm-2"></div></div></div></div>';
    let startHtml = '<div class="toast-modal-body"><div align="center" style="text-align: center;"><div class="row"><div class="col-sm-12" align="center"><h3 class="icon font-size-xl"><i class="fa fa-check-circle"></i></h2></div></div><div class="row"><div class="col-sm-12 msg"><h3 class="msg '+ this.getFontSizeClass() +'">';
    let endHtml = '</h3></div></div></div></div>';
    $('.overlay-container').css('display', 'block');
      let toast2 = this.toastr.success(startHtml+message+endHtml, title);
      if (toast2) {
        this.toastSub2 = toast2.onHidden.subscribe(() => {
          $('.overlay-container').css('display', 'none');
          this.toastSub2.unsubscribe();
          console.log("Dari App Management");
          console.log(window.opener.location);
          // console.log("Window loc");
          // console.log(window.location);
          window.opener.location.reload();
          window.close();
        });  
      }
      
  }

  showAnnouncement(message, title) {
   
    let startHtml = '<div class="toast-modal-body"><div align="center" style="text-align: center;"><div class="row"><div class="col-sm-12" align="center"><h3 class="icon font-size-xl"><i class="fa fa-bullhorn"></i></h2></div></div><div class="row"><div class="col-sm-12 msg"><h3 class="msg '+ this.getFontSizeClass() +'">';
    let endHtml = '</h3></div></div></div></div>';
    $('.overlay-container').css('display', 'block');
    //this.toastr.clear();
    //setTimeout(()=>{
      let toast3 = this.toastr.info(startHtml+message+endHtml, title, { timeOut: this.closeTimeout, extendedTimeOut: this.closeTimeout });
      this.toastSub3 = toast3.onHidden.subscribe(() => {
        $('.overlay-container').css('display', 'none');
        this.toastSub3.unsubscribe();
      });  
    //},1000)
      
  }

  public getFontSizeClass() {
    let px = parseInt(localStorage.getItem('customFontSize'));
    if (px == 0){
      return 'sizeS1';
    } else if (px == 1) {
      return 'sizeS2';
    } else if (px == 2) {
      return 'sizeS3';
    } else if (px == 3) {
      return 'sizeS4';
    } else if (px == -1) {
      return 'sizeS01';
    } else if (px == -2) {
      return 'sizeS02';
    } else if (px == -3) {
      return 'sizeS03';
    } else {
      return 'sizeS1';
    }
  }
  

  public setFontSize(dynum) {
      localStorage.setItem('customFontSize', dynum);
    //if (localStorage.getItem('customFontSize')) {
      //let dynum = parseInt(localStorage.getItem('customFontSize'));
      this.fontSize.sizeS = 14 + dynum + 'px';
      this.fontSize.sizeM = 19 + dynum + 'px';
      this.fontSize.sizeL = 23 + dynum + 'px';
      this.fontSize.no_styles = 0.9 + dynum*0.1 + 'em';
      this.setFontSizeData(this.fontSize); 
    //}
  }

  setFontType(fontName) {
    this.setFontTypeData(fontName); 
  }

  setColor(color) {
    this.setBgColorData(color); 
  }

  public loadFontSizeData() {
    setTimeout(() => {
      if (localStorage.getItem('customFontSize')) {
        //alert(localStorage.getItem('customFontSize'));
        let dynum = parseInt(localStorage.getItem('customFontSize'));
        this.fontSize.sizeS = 14 + dynum + 'px';
        this.fontSize.sizeM = 19 + dynum + 'px';
        this.fontSize.sizeL = 23 + dynum + 'px';
        this.fontSize.no_styles = 0.9 + dynum*0.1 + 'em'; 
      } else {
        let dynum = 0;
        this.fontSize.sizeS = 14 + dynum + 'px';
        this.fontSize.sizeM = 19 + dynum + 'px';
        this.fontSize.sizeL = 23 + dynum + 'px';
        this.fontSize.no_styles = 0.9 + dynum*0.1 + 'em';
      }
      this.setFontSizeData(this.fontSize); 
    })
    
}

  public loadFontTypeData() {
    setTimeout(() => {
      if (localStorage.getItem('customFontType')) {
        this.setFontTypeData(localStorage.getItem('customFontType')); 
      }
    });
  }

  public loadBgColorData() {
    setTimeout(() => {
      if (localStorage.getItem('themeColor')) {
        this.setBgColorData(localStorage.getItem('themeColor')); 
      }
    });
  }

  setFontTypeData(data) {
    this.fontTypeData.next(data);
  }

  setFontSizeData(data) {
    this.fontSizeData.next(data);
  }

  setBgColorData(data) {
    this.bgColor.next(data);
  }

  //setInvalidUser() {
  //  this.invalidUserStatus.next(true);
  //}

  public sentToGtag(contentId?) { 
    try {
      if (typeof gtag==='function') {
          let path;
          if (!contentId) {
            path= window.location.pathname + window.location.search
          } else {
            let firstPath;
            firstPath = location.pathname.split('/')[1];
            if (firstPath && firstPath.toLowerCase().startsWith('portal-protected')) {
              path = '/portal-protected/content/'+contentId+'?s=subcategory';
            } else if (firstPath && firstPath.toLowerCase().startsWith('portal')) {
              path = '/portal/content/'+contentId+'?s=subcategory';
            } else {
              path = '/content/'+contentId+'?s=subcategory';
            }
            
          }
          console.log(path);
          let title = document.title;
          //console.log(title);
          let desc = title.replace('MyGOV - ', '');
          let metaDesc = '';
          let descArr = desc.split('|');
          if (descArr && descArr.length > 0) {
            metaDesc = descArr[descArr.length -1].trim();
          }
          this.pageMeta.updateTag({ name: 'description', content: metaDesc }); 

          gtag('config', this.gaTrackingId, {
            'page_title': title,
            'page_path': path,
            'cookie_domain': 'auto'
            }); 
      }else {
        console.log('gtag not loaded');
      }
    } catch (e) {
      console.log(e);
    }
  }

  public setTitleAndGtag(title) {
    this.pageTitle.setTitle(title);
    let desc = title.replace('MyGOV - ', '');
    this.pageMeta.updateTag({ name: 'description', content: desc }); 
    try {
      if (typeof gtag==='function') {
          let path = window.location.pathname + window.location.search
          console.log(title); 
          gtag('config', this.gaTrackingId, {
            'page_title': title,
            'page_path': path,
            'cookie_domain': 'auto'
            }); 
      }else {
        console.log('gtag not loaded');
      }
    } catch (e) {
      console.log(e);
    }
  }

  public setTitle(title) {
    this.pageTitle.setTitle(title); 
  }

  getForbiddenList(){
    let dataUrl = 'assets/forbiddenlist.json';
    return this.http.get(dataUrl)
    .map((response: Response) => response.json())
    .catch(this.handleError);
  }

  getFeedbackMain(){
    return this.http.get(this.feebackMainUrl)
    .map((response: Response) => response.json())
    .catch(this.handleError);
  }

  getCountryData(kword?, sortby?): Observable<any[]> {
    let params;

    if(kword)
      params = '/find?keyword='+kword;
    else if(sortby)
      params = '/all?sort='+sortby;
    else
      params = '/all';

    return this.http.get(this.countryUrl+params)
      .map((response: Response) => response.json().countryList)
      .retry(5)
      .catch(this.handleError);

  }
  

  getCountryCodeData(): Observable<any[]> {

    return this.http.get(this.countryUrl)
      .map((response: Response) => response.json().countryList)
      .retry(5)
      .catch(this.handleError);

  }



  getStateData(): Observable<any[]> {

    return this.http.get(this.stateUrl)
      .map((response: Response) => response.json().stateList)
      .retry(5)
      .catch(this.handleError);

  }

  getPostCodeData(code): Observable<any[]> {

    return this.http.get(this.postcodeUrl+'id/'+ code)
      .map((response: Response) => response.json().postcodeList)
      .retry(5)
      .catch(this.handleError);
  }


   // NEW

  getStreetsNames(code): Observable<any[]> {

    return this.http.get(this.postcodeUrl+'id/'+ code)
      .map((response: Response) => response.json().postcodeList)
      .retry(5)
      .catch(this.handleError);
  }

  postDirect(url, body, isPrediction?) {

    // if(!lang){
    //   lang = localStorage.getItem('langID');
    // }
    
    let createUrl;

    if(isPrediction)
      createUrl = '/' + url;
    else
      createUrl = environment.infoTrafficURL+ url;

    return this.http.post(createUrl, body)
    .map((response: Response) => response.json())
    .catch(this.handleErrorProtected);

  }

  readDirect(url, lang?, params?): Observable<any[]> {

   let readUrl;

   if(!lang){
     lang = localStorage.getItem('langID');
   }

   if(!params){
     readUrl = url;
   } else if(params) {
     readUrl = url + params;
   } else {
     readUrl = url + '?language='+lang;
   }

   return this.http.get(readUrl)
     .map((response: Response) => response.json())
     .retry(5)
     .catch(this.handleError);
 }

   readPortal(moduleName, page?, size?, keyword?, lang?): Observable<any[]> {
    let readUrl;
    if(!lang){
      lang = localStorage.getItem('langID');
    }
    if(!keyword && page) {

      readUrl = this.config.urlPortal + moduleName + '?page=' + page + '&size=' + size  + '&language='+lang;
    } else if(keyword) {

      readUrl = this.config.urlPortal + moduleName + '?keyword='+keyword+'&page=' + page + '&size=' + size  + '&language='+lang;
    } else {

      readUrl = this.config.urlPortal + moduleName + '?language='+lang;
    }

    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);
  }

   readDSPublic(moduleName, page?, size?, keyword?, lang?): Observable<any[]> {
    let readUrl;
    if(!lang){
      lang = localStorage.getItem('langID');
    }
    if(!keyword && page) {

      readUrl = this.sharedDS + moduleName + '?page=' + page + '&size=' + size  + '&language='+lang;
    } else if(keyword) {

      readUrl = this.sharedDS + moduleName + '?keyword='+keyword+'&page=' + page + '&size=' + size  + '&language='+lang;
    } else {

      readUrl = this.sharedDS + moduleName + '?language='+lang;
    }

    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);
  }

  readProtected(moduleName, page?, size?, keyword?, lang?): Observable<any[]> {
    let readUrl;
    if(!lang){
      lang = localStorage.getItem('langID');
    }
    if(!keyword && page) {
      readUrl = this.config.urlProtected + moduleName + '?page=' + page + '&size=' + size  + '&language='+lang;
    } else if(keyword) {
      readUrl = this.config.urlProtected + moduleName + '?keyword='+keyword+'&page=' + page + '&size=' + size  + '&language='+lang;
    } else {
      readUrl = this.config.urlProtected + moduleName + '?language='+lang;
    }

    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleErrorProtected);
  }

  readPortalById(moduleName, id, lang?): Observable<any[]> {
    if(!lang){
      lang = localStorage.getItem('langID');
    }
    let readUrl = this.config.urlPortal + moduleName + id + '?language='+lang;

    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      // .retry(5)
      .catch(this.handleError);
  }

  readDSPublicById(moduleName, id, lang?): Observable<any[]> {
    if(!lang){
      lang = localStorage.getItem('langID');
    }
    let readUrl = this.sharedDS + moduleName + id + '?language='+lang;
    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleErrorProtected);
  }

  readProtectedById(moduleName, id, lang?): Observable<any[]> {
    if(!lang){
      lang = localStorage.getItem('langID');
    }
    let readUrl = this.config.urlProtected + moduleName + id + '?language='+lang;
    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleErrorProtected);
  }

  readDSProtectedById(moduleName, id, lang?): Observable<any[]> {
    if(!lang){
      lang = localStorage.getItem('langID');
    }
    let readUrl = this.config.urlAgencyDservice + moduleName + id + '?language='+lang;

    if (!environment.staging) {
      return this.http
      .get(readUrl).map((response: Response) => response.json())
      .catch(this.handleError);
    } else {
      let headers = new Headers({ 'REMOTE_USER': this.getDevUserId() });
      let options = new RequestOptions({ headers: headers });
      return this.http
      .get(readUrl, options).map((response: Response) => response.json())
      .catch(this.handleErrorProtected);
    }
  }

  create(data, moduleName, lang?) {
    if(!lang){
      lang = localStorage.getItem('langID');
    }
    let createUrl = this.config.urlProtected   + moduleName + '?language='+lang;

    return this.http.post(createUrl, data)
    .map((response: Response) => response.json())
    .catch(this.handleErrorProtected);
  }

  update(data,moduleName, lang?) {
    if(!lang){
      lang = localStorage.getItem('langID');
    }
    let updateUrl = this.config.urlProtected  + moduleName +'?language='+lang;

    return this.http.put(updateUrl, data)
    .map((response: Response) => response.json())
    .catch(this.handleErrorProtected);
  }

  delete(id,moduleName, lang?) {
    if(!lang){
      lang = localStorage.getItem('langID');
    }
    let deleteUrl = this.config.urlProtected  + moduleName + id+ '?language='+lang;

    return this.http.delete(deleteUrl, null)
    .map((response: Response) => response.json())
    .catch(this.handleErrorProtected);
  }

  getBMI(moduleName): Observable<any[]> {

    let readUrl = this.config.urlPortal + moduleName;
    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(1)
      .catch(this.handleError);
  }

  getSchoolLevel(moduleName, id): Observable<any[]> {
    let readUrl = this.sharedDS + moduleName + id;
    //let readUrl = this.tempSharedDS + 'getPeringkat.php';
    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);
  }

  getSchoolType(moduleName, id): Observable<any[]> {
    let readUrl = this.sharedDS + moduleName + id;
    //let readUrl = this.tempSharedDS + 'getPeringkat.php';
    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);
  }

  getSchoolAgent(moduleName, level): Observable<any[]> {

    let readUrl = this.sharedDS + moduleName + '?level='+level;
    //let readUrl = this.tempSharedDS + 'getEjenPelaksana.php?peringkat='+level;
    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);
  }

  getSchoolApi(moduleName, id, lang): Observable<any[]> {
    let readUrl = this.sharedDS + moduleName + id;
    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);
  }

  getListSchool(moduleName, category, negeri, sector, ppd, institusi, special, limit, offset, param): Observable<any[]> {

    let readUrl: any; //peringkat=3&ejen=9&jenis=1&pkhas=A&negeri=A
    // readUrl = this.tempSharedDS + 'getSchoolList.php?peringkat='+level+'&ejen='+agent+'&jenis='+type+'&pkhas='+special+'&negeri='+state;
    //readUrl = this.sharedDS + moduleName + '?limit='+limit+'&offset='+page+'&level='+level+'&agent='+agent+'&type='+type+'&special='+special+'&negeri='+state;
    readUrl = this.sharedDS + moduleName + '?category='+category+'&negeri='+negeri+'&sector='+sector+'&ppd='+ppd+'&institusi='+institusi+'&pkhas='+special+'&limit='+limit+'&offset='+offset+param;
  
    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(1)
      .catch(this.handleError);
  }

  getListSchoolAll(moduleName, category, negeri, sector, ppd, institusi, special, limit, offset, key?, keyType?): Observable<any[]> {

    let param='';
    if(key){
      param = '&filtertype='+keyType+'&filter='+key;
    }

    let readUrl: any; //peringkat=3&ejen=9&jenis=1&pkhas=A&negeri=A
    // readUrl = this.tempSharedDS + 'getSchoolList.php?peringkat='+level+'&ejen='+agent+'&jenis='+type+'&pkhas='+special+'&negeri='+state;
    // readUrl = this.sharedDS + moduleName + '?limit='+limit+'&offset='+page+'&level='+level+'&agent='+agent+'&type='+type+'&special='+special+'&negeri='+state;
    readUrl = this.sharedDS + moduleName + '?category='+category+'&negeri='+negeri+'&sector='+sector+'&ppd='+ppd+'&institusi='+institusi+'&pkhas='+special+'&limit='+limit+'&offset='+offset+param;
  
    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(1)
      .catch(this.handleError);
  }

  getListSchoolByLocation(moduleName, category, negeri, sector, ppd, institusi, special, limit, offset, x, y, dist, param): Observable<any[]> {

    let readUrl: any; //peringkat=3&ejen=9&jenis=1&pkhas=A&negeri=A
    readUrl = this.sharedDS + moduleName + '?category='+category+'&negeri='+negeri+'&sector='+sector+'&ppd='+ppd+'&institusi='+institusi+'&pkhas='+special+'&limit='+limit+'&offset='+offset+'&x='+x+'&y='+y+'&dist='+dist+param;
    // readUrl = this.sharedDS + 'school/list?limit='+limit+'&offset='+page+'&level='+level+'&agent=A&type=A&special=A&negeri=A&x='+long+'&y='+lat+'&dist='+distance;
    // readUrl = this.sharedDS + 'school/list?limit='+limit+'&offset='+page+'&level='+level+'&agent='+agent+'&type='+type+'&special=A&negeri=A&x='+long+'&y='+lat+'&dist='+distance;
    // readUrl = this.tempSharedDS + 'getSchoolList.php?peringkat='+level+'&ejen='+agent+'&jenis='+type+'&pkhas=A&negeri=A&x='+long+'&y='+lat+'&dist='+distance;
    // readUrl = this.sharedDS + moduleName + '?limit=15&offset='+page+'&level='+level+'&agent='+agent+'&type='+type+'&special=A&negeri=A'+'&dist='+distance;
    // http://10.1.71.168/webs/edu/getSchoolList.php?peringkat=3&ejen=9&jenis=1&pkhas=A&negeri=A&x=101.255932&y=4.196633&dist=5000

    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(1)
      .catch(this.handleError);
  }

  getListSchoolByLocationAll(moduleName, category, negeri, sector, ppd, institusi, special, limit, offset, x, y, dist, key?, keyType?): Observable<any[]> {

    
    let param='';
    if(key){
      param = '&filtertype='+keyType+'&filter='+key;
    }

    let readUrl: any; //peringkat=3&ejen=9&jenis=1&pkhas=A&negeri=A
    readUrl = this.sharedDS + moduleName + '?category='+category+'&negeri='+negeri+'&sector='+sector+'&ppd='+ppd+'&institusi='+institusi+'&pkhas='+special+'&limit='+limit+'&offset='+offset+'&x='+x+'&y='+y+'&dist='+dist+param;
    // readUrl = this.sharedDS + 'school/list?limit='+limit+'&offset='+page+'&level='+level+'&agent=A&type=A&special=A&negeri=A&x='+long+'&y='+lat+'&dist='+distance;
    // readUrl = this.sharedDS + 'school/list?limit='+limit+'&offset='+page+'&level='+level+'&agent='+agent+'&type='+type+'&special=A&negeri=A&x='+long+'&y='+lat+'&dist='+distance;
    // readUrl = this.tempSharedDS + 'getSchoolList.php?peringkat='+level+'&ejen='+agent+'&jenis='+type+'&pkhas=A&negeri=A&x='+long+'&y='+lat+'&dist='+distance;
    // readUrl = this.sharedDS + moduleName + '?limit=15&offset='+page+'&level='+level+'&agent='+agent+'&type='+type+'&special=A&negeri=A'+'&dist='+distance;
    // http://10.1.71.168/webs/edu/getSchoolList.php?peringkat=3&ejen=9&jenis=1&pkhas=A&negeri=A&x=101.255932&y=4.196633&dist=5000

    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(1)
      .catch(this.handleError);
  }

  getListSchoolByName(moduleName, schoolname, page?, limit?, param?): Observable<any[]> {
    
    let readUrl: any;
    readUrl = this.sharedDS + moduleName + '?limit='+limit+'&offset='+page+'&search='+encodeURIComponent(schoolname) + param;
    // readUrl = this.sharedDS + moduleName + '?limit='+limit+'&offset='+page+'&keyword='+schoolname;
        
    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(1)
      .catch(this.handleError);
  }

  getListSchoolByNameAll(moduleName, schoolname, page?, limit?, key?, keyType?): Observable<any[]> {

    let readUrl: any;
    let param='';
    if(key){
      param = '&filtertype='+keyType+'&filter='+key;
    }
    readUrl = this.sharedDS + moduleName + '?limit='+limit+'&offset='+page+'&search='+encodeURIComponent(schoolname)+param;
    // readUrl = this.sharedDS + moduleName + '?limit='+limit+'&offset='+page+'&keyword='+schoolname;

    console.log(encodeURIComponent(schoolname+param));

        
    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      // .retry(5)
      .catch(this.handleError);
  }


  getListDestination(moduleName, page, limit, param): Observable<any[]> {

    let readUrl: any;     
    let pageSize = '';

    if(page){
      pageSize = '&page='+page+'&size='+limit;
    }

    console.log("Cel: ", moduleName);
    readUrl = moduleName + pageSize + param;
    // readUrl = this.sharedDS + moduleName + '?limit='+limit+'&offset='+offset+param;

    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      // .retry(1)
      .catch(this.handleError);
  }

  getListPoint(moduleName, page, limit, param){

    let readUrl: any;     
    let pageSize = '';

    if(page){
      pageSize = '&page='+page+'&size='+limit;
    }

    readUrl = moduleName + pageSize;
    console.log("MASUK");
    console.log(readUrl);
    
    return this.http.post(readUrl, param)
      .map((response: Response) => response.json())
      .retry(1)
      .catch(this.handleError);
  }

  // END NEW

  errorHandling(err, callback){
    if(err && err.statusCode){
      let statusCode = err.statusCode.toLowerCase();
      if(statusCode == 'error'){
        this.showError(err.statusDesc, '');
      }else{
        callback();
      }
   } else {
     callback();
    }
  }
  

  getLatestAnnouncement(lang, type): Observable<any[]> {
    return this.http.get(this.urlAlert + '/'+type+'?language='+lang)
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }


  getCountrybyCode(code): Observable<any[]> {
    return this.http.get(this.countryUrl + '/code/' + code)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);

  }

  getCitiesbyState(code): Observable<any[]> {
    return this.http.get(this.cityUrl + code)
      .map((response: Response) => response.json().cityList)
      .retry(5)
      .catch(this.handleError);
  }

  getReligion(langId): Observable<any[]> {
    return this.http.get(this.religionUrl + langId)
      .map((response: Response) => response.json().religionList)
      .retry(5)
      .catch(this.handleError);
  }

  getRace(langId): Observable<any[]> {
    return this.http.get(this.raceUrl + langId)
      .map((response: Response) => response.json().raceList)
      .retry(5)
      .catch(this.handleError);
  }

  getCitizenship(langId): Observable<any[]> {
    return this.http.get(this.citizenUrl+"?language="+langId)
      .map((response: Response) => response.json().userTypeList)
      .retry(5)
      .catch(this.handleError);
  }

  getRelationship(langId): Observable<any[]> {
    return this.http.get(this.relationUrl + '?language='+langId + '&page=1&size=99')
      .map((response: Response) => response.json().userRelationshipList)
      .retry(5)
      .catch(this.handleError);
  }

  getReason(langId): Observable<any[]> {
    return this.http.get(this.reasonUrl + '?language='+langId + '&page=1&size=99')
      .map((response: Response) => response.json().accountStatusReasonList)
      .retry(5)
      .catch(this.handleError);
  }

  getGender(langId): Observable<any[]> {
    return this.http.get(this.genderUrl + langId)
      .map((response: Response) => response.json().genderList)
      .retry(5)
      .catch(this.handleError);
  }

  getThemeColor(){
    return this.http.get(this.colorUrl)
    .map((response: Response) => response.json().colorList)
    .retry(5)
    .catch(this.handleError);
  }


  getThemeFont(){
    return this.http.get(this.fontUrl)
    .map((response: Response) => response.json().fontList)
    .retry(5)
    .catch(this.handleError);
  }


  getTheme() {
    return localStorage.getItem('themeColor');
  }

  loadTranslate(){
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      const myLang = this.translate.currentLang;
      if (myLang == 'en') {
        this.translate.get('HOME').subscribe((res: any) => {
            this.lang = 'en';
            this.languageId = 1;
        });
      }
      if (myLang == 'ms') {
        this.translate.get('HOME').subscribe((res: any) => {
            this.lang = 'ms';
            this.languageId = 2;
        });
      }
    });
  }

  public reloadAfterExpired = ()=> {

    if (this.isAlreadyExpired.getValue() == true) {
      return null;
    }
    this.isAlreadyExpired.next(true);
    //location.reload();
  
    let expiredMsg;
    /*if (!this.languageId || this.languageId== 1) {
      expiredMsg = 'Your login session may have expired. Please login again.';
    } else {
      expiredMsg = 'Sesi log masuk mungkin telah tamat. Sila log masuk semula.';
    }*/
    expiredMsg = this.translate.instant('common.sessionerr');
    setTimeout(()=> {
      this.showError(expiredMsg,'', ()=>{ 
        window.location.replace(this.config.urlUAP +'portal/index');
      });
    },400);
    return null;
  }

  public handleErrorProtected = (error: any) => {
    //let msg = `Status code ${error.status} on url ${error.url}`;
    
    if (!error.response && error.status == 0) {
      console.log('cors problem');
      console.log(error);
      this.invalidUserStatus.next(true);
      this.reloadAfterExpired();
    } else if (error.status && (error.status == 401 || error.status == 0)) {
      console.log('unauthorized');
      console.log(error);
      this.invalidUserStatus.next(true);
      this.reloadAfterExpired();
    } else {
      let obj = {
        '_body':
        {
          statusDesc: 'General Error'
        }
      };

      if (error.error instanceof ErrorEvent) {
        obj._body.statusDesc = 'Unexpected Error: ' + error.error.message;
      } else {
        obj._body.statusDesc = 'Unexpected Server Error: ' + error.status + '. ' + error.message;
      }
      return Observable.throw(obj._body.statusDesc);
    }
  }

  public handleError = (error: any) => {
    //let msg = `Status code ${error.status} on url ${error.url}`;
      // console.log('cors problem');
      console.log(error);

      let obj = {
        '_body':
        {
          statusDesc: 'General Error'
        }
      };

      if (!error.response) {
        return Observable.throw(null);
      }
      if (error.error instanceof ErrorEvent) {
        obj._body.statusDesc = 'Unexpected Error: ' + error.error.message;
      } else {
        obj._body.statusDesc = 'Unexpected Server Error: ' + error.status + '. ' + error.message;
      }
      return Observable.throw(obj._body.statusDesc);   
  }

  getFEConfig() {
    return this.http.get(this.localConfigUrl)
    .map((response: Response) => response.json())
    .catch(this.handleError);
  }

  getLOAResult1(url: string) {
    return this.http.get(url)
    .map((response: Response) =>  response.json())
    .catch(this.handleLOAError);
  }

  getLOAResult2(url: string) {
    let options = this.getHeaders();
    return this.http.get(url, options)
    .map((response: Response) =>  response.json())
    .catch(this.handleLOAError);
  }

  getLOA(url: string, body: any) {
    let options = this.getHeaders();
    return this.http.get(url, options)
    .map((response: Response) =>  response.json())
    .catch(this.handleLOAError);
  }

  requestLOAData(url: string, reqType: string, data?: any) {
    let options = this.getHeaders();
    if (reqType == 'GET') {
      return this.http.get(url, options)
      .map((response: Response) =>  response.json())
      .catch(this.handleLOAError);
    } else {
      return this.http.post(url, data, options)
      .map((response: Response) =>  response.json())
      .catch(this.handleLOAError);
    }
  }

  getHeaders(): RequestOptions {
    let options;
    if (!environment.staging) {
      let optionsArgs: RequestOptionsArgs = { withCredentials: true }
      options = new RequestOptions(optionsArgs);
    } else {
      let headers = new Headers({ 'REMOTE_USER': this.getDevUserId() });
      options = new RequestOptions({ headers: headers });
    }
    return options;
  }
  
  public handleLOAError = (error: any) => {
    console.log('handleLOAError', error);
    if (error.status == 401) {
      return Observable.throw('ERROR_401');
    } else if (error.status == 404) {
      return Observable.throw('ERROR_404');
    } else if (error.status == 500) {
      return Observable.throw(error);
    } else if (!error.response && error.status == 0) {
      return Observable.throw('ERROR_0');
    } else {
      return Observable.throw('ERROR_'+ error.status);
    }
  }

  /*removeAllHtml(str) {
    if (str) {
      str = str.replace( /<(?:(?:(?:(script|style|object|embed|applet|noframes|noscript|noembed)(?:\s+(?:"[\S\s]*?"|'[\S\s]*?'|(?:(?!\/>)[^>])?)+)?\s*>)[\S\s]*?<\/\1\s*(?=>))|(?:\/?[\w:]+\s*\/?)|(?:[\w:]+\s+(?:"[\S\s]*?"|'[\S\s]*?'|[^>]?)+\s*\/?)|\?[\S\s]*?\?|(?:!(?:(?:DOCTYPE[\S\s]*?)|(?:\[CDATA\[[\S\s]*?\]\])|(?:--[\S\s]*?--)|(?:ATTLIST[\S\s]*?)|(?:ENTITY[\S\s]*?)|(?:ELEMENT[\S\s]*?))))>/g,
             "");
    }
    return str;
  }*/

  sanitizeHTML(str, offMessage?) {
    if (!str) {
      return str;
    }
    let sanitizeStr = this.sanitizer.sanitize(SecurityContext.HTML, str);
    if (str !== sanitizeStr) {
      if (!offMessage) {
        return this.translate.instant('sanitizemsg') + sanitizeStr;
      } else {
        return sanitizeStr;
      }  
    } else {
      return str;
    }
  }


} //end of sharedservice


// WEBPACK FOOTER //
// ./src/app/common/shared.service.ts